import * as z from 'zod';

export type SubscriptionFormSchemaValues = z.infer<typeof subscriptionFormSchema>;
export const subscriptionFormSchema = z.object({
    start_date: z.string(),
    end_date: z.string().optional(),
    service_plan: z.string().nonempty(),
    customer: z.string().nonempty(),
    has_active_billing: z.boolean(),
});
